module.exports = __webpack_public_path__ + "media/packs/images/flags/BB-6e8e82fba12caa17f34203f5358a21c0.png";